const urlOrigin = window.location.origin;
const reg = /https:\/\/designated([-0-9a-zA-Z*]*).wsecar.com/;
const result = urlOrigin.match(reg);
const env = result ? result[1] : '';
console.log(result, env);
const baseUrl = `https://daijiacarownergateway${env}.wsecar.com:8601`;
const url = `https://daijiadrivergateway${env}.wsecar.com:8501`;
const marketUrl = `https://marketapi${env}.wsecar.com`;
const loginUrl = `https://passengergateway${env}.wsecar.com:8601`;
const loginSjUrl = `https://daijiadrivergateway${env}.wsecar.com:8501`;

export default {
  env,
  baseUrl,
  url,
  marketUrl,
  loginUrl,
  loginSjUrl
};
